export const brandToCaseMap = {
  seek: 'SEEK',
  jobsdb: 'Jobsdb',
  jobstreet: 'Jobstreet',
} as const;
